module.exports = __webpack_public_path__ + "img/project3_1.png.b882b47f.webp";